import { formatHotelSearchAmountForDisplay } from "../../../constants/hotelCurrencies";

/**
 * תצוגת מחיר ל-trace חיפוש מלון — עוטף את אותה לוגיקה כמו פרופיל מלון / תוצאות חיפוש.
 */
export function formatTraceHotelSearchPriceDisplay(value, currencyCode) {
  return formatHotelSearchAmountForDisplay(value, currencyCode);
}

export function formatTraceNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  if (Math.abs(n) >= 1000 || Math.abs(n - Math.round(n)) < 1e-9) {
    return n.toLocaleString(undefined, { maximumFractionDigits: 2 });
  }
  return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 4 });
}

export function dashIfEmpty(formatted) {
  if (formatted === null || formatted === undefined || formatted === "") return "—";
  return formatted;
}

export function formatPercent(value) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return `${n.toFixed(2)}%`;
}

export function buildSummaryTextLines(trace) {
  const s = trace?.summary || {};
  const base = [
    `Entity: ${trace?.entityName || "—"}`,
    `Entity type: ${trace?.entityType || "—"}`,
    `Entity id: ${trace?.entityId ?? "—"}`,
    `API Price: ${s.apiRaw != null ? s.apiRaw : "—"}`,
    `Display Price: ${s.finalDisplay != null ? s.finalDisplay : "—"}`,
    `Delta: ${s.deltaAbs != null ? s.deltaAbs : "—"}`,
    `Currency: ${s.displayCurrency || "—"}`,
    `Commission: ${s.commissionTotal != null ? s.commissionTotal : "—"}`,
  ];
  if (trace?.entityType === "package") {
    base.push(
      `Flight (src): ${s.flightPrice != null ? s.flightPrice : "—"}`,
      `Hotel (src): ${s.hotelPrice != null ? s.hotelPrice : "—"}`,
      `Extras: ${s.extras != null ? s.extras : "—"}`,
      `Total before commission (ILS): ${s.totalBeforeCommission != null ? s.totalBeforeCommission : "—"}`
    );
  }
  base.push(
    `Anomalies: ${Array.isArray(trace?.anomalies) && trace.anomalies.length ? trace.anomalies.map((a) => a.code).join(", ") : "none"}`
  );
  return base.join("\n");
}

export function traceToCsvRows(steps) {
  if (!Array.isArray(steps) || steps.length === 0) return "";
  const cols = [
    "step",
    "layer",
    "field",
    "rawValue",
    "normalized",
    "currency",
    "exchangeRate",
    "fx_source",
    "fx_rate",
    "commission_plan",
    "commission_type",
    "commission_value",
    "is_applied",
    "rooms",
    "passengers",
    "commissionPercent",
    "commissionAmount",
    "markup",
    "discount",
    "beforeRound",
    "afterRound",
    "display",
    "anomaly",
    "notes",
    "sourceFile",
    "sourceFunction",
  ];
  const esc = (v) => {
    if (v === null || v === undefined) return "";
    const s = String(v).replace(/"/g, '""');
    return `"${s}"`;
  };
  const header = cols.join(",");
  const body = steps
    .map((row) => cols.map((c) => esc(row[c])).join(","))
    .join("\n");
  return `${header}\n${body}`;
}
